import React from 'react';
var AlertIcon = function () {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" },
        React.createElement("path", { fill: "#EA4335", fillRule: "evenodd", d: "M13.092 5.421a1.2 1.2 0 00-2.123.04l-6.04 11.997a1.2 1.2 0 001.072 1.74H18a1.2 1.2 0 001.075-1.732L13.316 5.828l-.224-.407zM11.33 9.574a.662.662 0 011.323 0v4.162a.662.662 0 01-1.323 0V9.574zm0 6.171a.662.662 0 111.323 0v.048a.662.662 0 01-1.323 0v-.048z", clipRule: "evenodd" })));
};
export default AlertIcon;
